import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Consts } from '@commons/consts/consts';
import { Vehicle } from '@commons/models/domain/Vehicle';
import { VehicleControlIndicator } from '@commons/models/domain/VehicleControlIndicator';
import { filterBinaryParams } from '@src/app/utils/params-binary-vehicle';

@Component({
  selector: 'app-controls-status',
  templateUrl: './controls-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./control-status.component.scss'],
})
export class ControlsStatusComponent {

  @Input('data') set data(value: Vehicle) {
    this.getControls(value);
  }

  public controls: VehicleControlIndicator[] = [];
  public hiddenControlCount: number = 0;

  constructor() { }

  private getControls(data: Vehicle): void {
    const params = data ? data.ControlIndicators?.filter(param => param && Consts.binaryIndicators.indexOf(param.Tp) !== -1) : [];
    this.controls = params ? params.filter(item => filterBinaryParams(item)).sort((a, b) => (a.Nm >= b.Nm ? 1 : -1)) : [];
    this.hiddenControlCount = this.controls.length - 3;
    this.controls = this.controls.splice(0, 3);
  }

}
